<script>

export default {
  props: ['item'],
  components: {  },
  data() {
    return {
      scroll_offset: 100,
    }
  },
  created() {
    
  },
  methods: {
    scrollTo(id) {
      var myElement = document.getElementById(id);
      var topPos = myElement.offsetTop + -this.scroll_offset;
      document.getElementById('scrolldataoutput').scrollTo({top: topPos, behavior: 'smooth'});
    },
  }
}
</script>

<template>
  <div>
    <div class="row mx-0">
      <div class="d-none d-sm-block _w-160 border-right border-light">
        <div class="text-right sticky-top _pos-t-115">
          <button type="button" :target="'print_output'" class="btn btn-light small print_target mr-4 mb-3 px-4"><Icon icon="ri:printer-line" /> Print</button>
          <b-list-group v-b-scrollspy="{element: '#scrolldataoutput', offset: scroll_offset}" class="scrollspy-list small">
            <b-list-group-item href="#zform-data" @click.prevent="scrollTo('zform-data')">Form Data</b-list-group-item>
            <b-list-group-item href="#zlisting-data" @click.prevent="scrollTo('zlisting-data')">Listing Data</b-list-group-item>
            <b-list-group-item href="#zsign-company" @click.prevent="scrollTo('zsign-company')">Sign Company</b-list-group-item>
            <b-list-group-item href="#zpackages-services" @click.prevent="scrollTo('zpackages-services')">Packages/Services</b-list-group-item>
            <b-list-group-item href="#zvaluations" @click.prevent="scrollTo('zvaluations')">Valuations</b-list-group-item>
          </b-list-group>
        </div>
      </div>
      <div class="col p-0">
        <div id="scrolldataoutput" style="position:relative;height:calc(100vh - 200px);overflow-y:auto;">
          <div :id="'print_output'" class="p-4">
            <h5 id="zform-data" class="section-header mb-3"><Icon icon="ri:book-2-line"></Icon> Form Data :</h5>
            <div class="table-responsive">
              <table class="table table-sm table-px-0">
                <tbody>
                  <tr v-for="(field, field_i) in item.additional_input" :key="'a'+field_i">
                    <th class="text-nowrap _w-200"><label>{{ field_i }} :</label></th><td class="small">{{ item.additional_input[field_i] }}</td>
                  </tr>
                </tbody>
              </table>
            </div>
            <h5 id="zlisting-data" class="section-header mb-3"><Icon icon="ri:book-2-line"></Icon> Listing Data :</h5>
            <div class="table-responsive">
              <table class="table table-sm table-px-0">
                <tbody>
                  <tr v-for="(field, field_i) in item" :key="'a'+field_i"  v-if="typeof field != 'array' && typeof field != 'object'">
                    <th class="text-nowrap _w-200"><label>{{ field_i }} :</label></th><td class="small">{{ item[field_i] }}</td>
                  </tr>
                </tbody>
              </table>
            </div>
            <h5 id="zsign-company" class="section-header mb-3"><Icon icon="ri:book-2-line"></Icon> Sign Company :</h5>
            <div class="table-responsive">
              <table class="table table-sm table-px-0">
                <tbody>
                  <tr v-if="item.sign_company" v-for="(field, field_i) in item.sign_company" :key="'a'+field_i">
                    <th class="text-nowrap _w-200"><label>{{ field_i }} :</label></th><td class="small">{{ field }}</td>
                  </tr>
                </tbody>
              </table>
            </div>
            <h5 id="zpackages-services" class="section-header mb-3"><Icon icon="ri:book-2-line"></Icon> Packages/Services :</h5>
            <div class="table-responsive">
              <table class="table table-sm table-px-0">
                <tbody>
                  <tr>
                    <th class="text-nowrap _w-200"><label>Active Package :</label></th>
                    <td v-if="item.active_package" class="small">
                      <div class="font-weight-bold">{{ item.active_package.title }}</div>
                      <div v-if="item.active_package.services" v-for="(service, service_i) in item.active_package.services" :key="service_i">{{service.title}}</div>
                    </td>
                  </tr>
                  <tr>
                    <th class="text-nowrap _w-200"><label>A La Carte :</label></th>
                    <td v-if="item.carts" class="small">
                      <div v-for="(cart, cart_i) in item.carts" :key="cart_i">
                        <div v-for="(serv, serv_i) in cart.services" :key="serv_i">{{ serv.title }}</div>
                      </div>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
            <h5 id="zvaluations" class="section-header mb-3"><Icon icon="ri:book-2-line"></Icon> Valuations :</h5>
            <div class="table-responsive">
              <table class="table table-sm table-px-0">
                <tbody>
                  <tr v-if="item.valuations" v-for="(field, field_i) in item.valuations" :key="'a'+field_i">
                    <th class="text-nowrap _w-200"><label>{{ field_i }} :</label></th><td class="small"><span v-if="field.amount">{{ formatPrice(field.amount, true, false) }}</span></td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
